<template>
  <header class="tw-mb-11">
    <h2 class="tw-text-[1.7rem] tw-font-bold">
      {{ t('auth.titles.select_workspace').toUpperCase() }}
    </h2>
    <p class="tw-text-base tw-font-light">{{ t('auth.titles.select_workspace_description') }}</p>
  </header>

  <div
    v-if="errorMessage"
    class="tw-bg-red-100 tw-border tw-border-red-400 tw-text-red-700 tw-px-4 tw-py-3 tw-rounded tw-mb-4"
    role="alert"
  >
    {{ errorMessage }}
  </div>

  <div class="tw-flex tw-flex-col tw-gap-3 tw-mt-6">
    <div
      v-for="tenant in availableTenants"
      :key="tenant.id"
      class="tw-flex tw-items-center tw-justify-between tw-p-4 tw-border tw-border-gray-200 tw-rounded-lg tw-cursor-pointer tw-transition-all tw-duration-200 hover:tw-border-blue-500 hover:tw-bg-blue-50"
      :class="{ 'tw-opacity-70 tw-cursor-wait': isLoading && selectedTenantId === tenant.id }"
      @click="onTenantSelect(tenant.id)"
    >
      <div class="tw-flex tw-items-center tw-gap-3">
        <div class="tw-w-10 tw-h-10 tw-rounded-lg tw-overflow-hidden">
          <img
            v-if="tenant.logo"
            :src="tenant.logo"
            :alt="tenant.name"
            class="tw-w-full tw-h-full tw-object-cover"
          />
          <div
            v-else
            class="tw-w-full tw-h-full tw-flex tw-items-center tw-justify-center tw-bg-blue-500 tw-text-white tw-font-semibold tw-text-xl"
          >
            {{ tenant.name.charAt(0).toUpperCase() }}
          </div>
        </div>
        <span class="tw-font-medium tw-text-gray-800">{{ tenant.name }}</span>
      </div>
      <i
        v-if="isLoading && selectedTenantId === tenant.id"
        class="icon-spinner tw-animate-spin tw-text-gray-400"
      ></i>
      <i v-else class="icon-chevron-right tw-text-gray-400"></i>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useAuthStore } from '@/stores/auth.store';
import { storeToRefs } from 'pinia';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const { availableTenants, errorMessage } = storeToRefs(useAuthStore());
const { selectTenant } = useAuthStore();

const isLoading = ref(false);
const selectedTenantId = ref<number | null>(null);

const onTenantSelect = async (tenantId: number) => {
  if (isLoading.value) return;

  isLoading.value = true;
  selectedTenantId.value = tenantId;

  try {
    await selectTenant(tenantId);
  } finally {
    isLoading.value = false;
    selectedTenantId.value = null;
  }
};
</script>

<style scoped>
/* Using Tailwind classes - no additional styles needed */
</style>
